import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { mask } from 'vue-the-mask';
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-163692168-1',
  router,
});

new Vue({
  router,
  store,
  vuetify,
  mask,
  render: h => h(App)
}).$mount('#app');
